export default __webpack_public_path__ + "static/media/Group 3183@2x.5b1b1ba3.png";